import { ConsolidationDefinitionDTO } from "../DTO/consolidationDefinitionDTO";
import { ConsolidationRule } from "./consolidationRule";
import { ConsolidationRuleDefinition } from "./consolidationRuleDefinition";
import { FieldDefinition } from "./fieldDefinition";
import { FileDefinition } from "./fileDefinition";

export class ConsolidationDefinition{

    public id!: number;
    public name!: string;
    public description!: string;
    public fileDefinition!: FileDefinition;
    public consolidationRules!: ConsolidationRule[];
    public consolidationFieldReferences!: FieldDefinition[];
    public sortFieldReferences!: FieldDefinition[];
    public sortDesc!: boolean;
    public version!: number; //incremental version number set by server
    public published!: boolean; //if true, then can be used for moovs and can be loaded by other users
    public added!: Date;
    public deleted!: boolean;
    public ownedByEntityId!: number;
    public ownerEntityType!: string;

    constructor(){
        this.consolidationRules = new Array();
        this.consolidationFieldReferences = new Array();
    }

    public setFileDefinition(fd:FileDefinition){
        //use this method to correctly instantiate the protocols
        this.fileDefinition=fd;
        if(fd) this.consolidationRules.forEach(p=>p.createInputField(fd.fieldDefinitions));
    }

    public static mapFromDTO(param:ConsolidationDefinitionDTO):ConsolidationDefinition{ 
        if (!param) throw new Error("parameter is null")
        let obj = new ConsolidationDefinition();
        try
        {
            obj.id = param.id;
            obj.name = param.name;
            obj.description = param.description;
            obj.consolidationRules = param.consolidationRules.map(cr=>ConsolidationRule.mapFromDTO(cr));
            if(param.consolidationFieldReferences){
                obj.consolidationFieldReferences = JSON.parse(param.consolidationFieldReferences);
            }
            if(param.sortFieldReferences){
                obj.sortFieldReferences = JSON.parse(param.sortFieldReferences);
            }
            obj.sortDesc = param.sortDesc;
            obj.version = param.version;
            obj.published = param.published;
            obj.added = new Date(param.added);
            obj.deleted = param.deleted;
            obj.ownedByEntityId = param.ownedByEntityId;
            obj.ownerEntityType = param.ownerEntityType;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:ConsolidationDefinition):ConsolidationDefinitionDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new ConsolidationDefinitionDTO();
        try
        {
            dto.id = param.id;
            dto.name = param.name;
            dto.description = param.description;
            dto.fileDefinitionId = param.fileDefinition.id!;
            if(param.consolidationFieldReferences) dto.consolidationFieldReferences = JSON.stringify(param.consolidationFieldReferences);
            if(param.sortFieldReferences) dto.sortFieldReferences = JSON.stringify(param.sortFieldReferences);
            dto.sortDesc = param.sortDesc;
            dto.consolidationRules = param.consolidationRules.map(cr=>ConsolidationRule.mapToDTO(cr));
            dto.version = param.version;
            dto.published = param.published;
            if(param.added) dto.added = param.added.toISOString();
            dto.deleted = param.deleted;
            dto.ownedByEntityId = param.ownedByEntityId;
            dto.ownerEntityType = param.ownerEntityType;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

    get status():string{
        return this.deleted?"Inactive":"Active";
    }

    //use DTO to create a deep copy
    get clone():ConsolidationDefinition{
        //memorize used consolidationRuleDefinitions first
        let usedConsolidationRuleDefinitions:ConsolidationRuleDefinition[]=[];
        this.consolidationRules.forEach(cr=>{
            if(usedConsolidationRuleDefinitions.findIndex(crd=>crd.id==cr.consolidationRuleDefinition.id)==-1){
                usedConsolidationRuleDefinitions.push(cr.consolidationRuleDefinition);
            }
        });
        let mappedConsolidationDefinition=ConsolidationDefinition.mapToDTO(this);
        mappedConsolidationDefinition.id=0;
        mappedConsolidationDefinition.name="";
        mappedConsolidationDefinition.version=0;
        mappedConsolidationDefinition.description="";
        mappedConsolidationDefinition.published=false;
        mappedConsolidationDefinition.consolidationRules.forEach(cr=>{
            cr.id=0;
        });
        let mapFromDTOConsolidationDefinition = ConsolidationDefinition.mapFromDTO(mappedConsolidationDefinition);
        mapFromDTOConsolidationDefinition.setFileDefinition(this.fileDefinition);
         //relate consolidationRuleDefinitions with clone
         mapFromDTOConsolidationDefinition.consolidationRules.forEach(cr=>{
                cr.consolidationRuleDefinition=usedConsolidationRuleDefinitions.find(crd=>crd.id==cr.consolidationRuleDefinitionId)!;
        });
        return mapFromDTOConsolidationDefinition;
    }

    public resetIds(){
        this.id=0;
        this.consolidationRules.forEach(cr=>{
            cr.id=0;
        });
    }

    get acceptFileTypes(){
        let types=".txt";
        if(this.fileDefinition?.type=='csv') types+=",.csv,.xml";
        return types
    }
}